export const getMSTwoWayUrl = (integrationsUrl: string, orgSlug: string) => {
    return `${integrationsUrl}/login?integrationType=microsoft&orgSlug=${orgSlug}&forTwoWaySync=true`;
};
